/*
 * @author  leiling.cp
 * @version 0.0.1
 * @date    2014/9/20
 * @update  2014/11/4
 * @description 插件api模块，完成插件的一系列操作
 */



    var $ = require("@alife/alpha-jquery/jquery");
    var Base = require("@alife/alpha-base/base");
    var Cookie = require("@alife/alpha-cookie/cookie");
    var ListLoad = require("./list-load");
    var StoreProxy = require('@alife/alpha-store-proxy/store-proxy');;
    var isAlibaba = !!location.hostname.match(/alibaba\.com/);

    var ATM_CLIENT_CHECK = 'atm-client-check';
    var LOAD_MAXTIME = 3000;            // 5 seconds
    var CHECK_LIFETIME = 3600 * 1000;   // one hour
    var CLIENT_URL_LIST = [
        'https://localhost.wwbizsrv.alibaba.com:4013/?callback=?',
        'https://localhost.wwbizsrv.alibaba.com:4813/?callback=?',
        'http://localhost.wwbizsrv.alibaba.com:4012/?callback=?',
        'http://localhost.wwbizsrv.alibaba.com:4812/?callback=?'
    ];
    var ATMPlugin = Base.extend({
        initialize: function () {
            var that = this;

            this.cfg = {
                // 用于Firefox插件升级,如此处设置的更新版本是1.0.0.1
                // 则程序会用1.0.0.1和当前插件版本比对,如果大于当前版本,会提示用户升级
                // 修改此值前请先将插件布署到服务器
                updateVersion: '1.0.0.1',
                // Firefox&Chrome plugin下载安装地址
                pluginDownloadUrl: location.protocol + '//download.wangwang.1688.com/aliim/AliIM6_ATM/bin/TMnpSetup.exe',
                // ATM客户端(WW)下载页面
                clientDownloadUrl: location.protocol + '//trademanager.alibaba.com/'
            };
            this.pluginMime = navigator.mimeTypes['application/atm-plugin'];
            this.hasClient = false;
            this.atm = null;
            this.checked = false;

            // TradeManger客户端版本标识,-1:未安装; 0:<6.0版本; 1:6.0及以上版本; 2: firefox(6.0及以上版本) 3: for Chrome版本
            this.atmClientFlag = -1;

            // 浏览器支持情况
            this.isBrowserSupport = this.isMac() ? (this.isFirefox() || this.isChrome() || this.isOpera() || this.isSafari()) : (this.isIE() || this.isFirefox() || this.isChrome());

            if (this.isBrowserSupport && this.isClientReady()) {
                this.hasClient = true;
            } else if (isAlibaba) {
                this.getCheckCache(function (hasClient) {
                    if (typeof hasClient === 'boolean') {
                        that.hasClient = hasClient;

                        if (hasClient) {
                            that.atmClientFlag = 3;
                        }
                    } else {
                        // 异步请求本地HTTP服务, 确定客户端是否已安装
                        that.whenPageLoad(function () {
                            /*@debug
                            console.log('begin to check ...');
                             */
                            that.detectClientService();
                        });
                    }
                }, function () {
                    // 异步请求本地HTTP服务, 确定客户端是否已安装
                    that.whenPageLoad(function () {
                        /*@debug
                        console.log('begin to check ...');
                         */
                        that.detectClientService();
                    });
                });
            }
        },
        whenPageLoad: function (cb) {
            var that = this;
            /*@debug
            console.log('wait for onload ...');
             */

            ListLoad.set('delay', LOAD_MAXTIME);
            ListLoad.load(function () {
                if (that.checked) {
                    return;
                }
                that.checked = true;

                cb.call(that);
            });
        },
        getCheckCache: function (success, falied) {
            StoreProxy.get(ATM_CLIENT_CHECK, {
                filter: function (val) {
                    try {
                        val = JSON.parse(val);
                    } catch (e) {
                        val = {
                            time: 0,
                            hasClient: false
                        };
                    }

                    var now = new Date().getTime();

                    if (now - val.time < CHECK_LIFETIME) {
                        return val.hasClient;
                    } else {
                        return null;
                    }
                }
            }, function (err, data) {
                if (err) {
                    if (typeof falied === 'function') {
                        falied(err);
                    }
                    return;
                } else {
                    if (typeof success === 'function') {
                        success(data);
                    }
                }
            });
        },
        setCheckCache: function (hasClient) {
            var data = JSON.stringify({
                time: new Date().getTime(),
                hasClient: hasClient
            });

            StoreProxy.set(ATM_CLIENT_CHECK, data);
        },
        detectClientService: function (i) {
            // skip mac
            if (this.isMac()) {
                return;
            }

            i = i | 0;

            var that = this;
            var url = CLIENT_URL_LIST[i];

            if (!url) {
                this.setCheckCache(false);
                return;
            }

            $.ajax({
                type: 'GET',
                url: url,
                dataType: 'jsonp',
                cache: false,
                timeout: 10000, // 10秒超时
                success: function () {
                    that.hasClient = true;
                    that.atmClientFlag = 3;

                    // write session the check result
                    that.setCheckCache(true);
                    /*@debug
                    console.log('detectClientService: success');
                     */
                },
                error: function () {
                    /*@debug
                    console.log('detectClientService: error');
                     */
                    that.detectClientService(i + 1);
                }
            });
        },
        isIE: function () {
            return $.browser.ie || (/MSIE ([^;]*)|Trident.*; rv(?:\s|:)?([0-9.]+)/).test(window.navigator.userAgent);
        },
        isFirefox: function (ver) {
            var self = this;
            var _match = navigator.userAgent.match(/Firefox\/(\d*)\..*/i);
            if (_match) {
                self.firefoxVer = parseFloat(_match[1]);
            } else {
                self.firefoxVer = '';
            }
            return !!_match && parseFloat(_match[1]) >= (ver || 1.5);
        },
        isMac: function () {
            return (navigator.platform.indexOf('Mac') > -1);
        },
        isChrome: function () {
            return (window.navigator.userAgent.indexOf('Chrome') !== -1);
        },
        isOpera: function () {
            return (window.navigator.userAgent.indexOf('Opera') !== -1);
        },
        isSafari: function () {
            return (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') < 1);
        },
        numberify: function (s) {
            var c = 0;
            return parseFloat(s.replace(/\./g, function () {
                return (c++ === 0) ? '.' : '';
            }));
        },
        checkClient: function () {
            var self = this;

            // TODO ==== 不能这么写
            // if (arguments.callee.counter == 1) {
            //     return;
            // }
            // Win 操作系统下
            if (!self.isMac()) {
                if (self.isIE()) {
                    try {
                        // ATM 客户端6.0及以上版本
                        self.atm = new ActiveXObject('aliimx.atmx');
                        self.atmClientFlag = 1;
                    } catch (e) {
                        try {
                            // ATM 客户端6.0以下版本
                            self.atm = new ActiveXObject('TradeManagerSetup.Install.1');
                            self.atmClientFlag = 0;
                        } catch (ex) {
                            self.atmClientFlag = -1;
                        }
                    }
                } else if (self.isFirefox() || self.isChrome()) {
                    if (!!self.pluginMime) {
                        var plugin = document.createElement("embed");
                        plugin.setAttribute('type', 'application/atm-plugin');
                        plugin.style.height = '0px';
                        plugin.style.width = '0px';
                        plugin.style.visibility = 'hidden';
                        self.atm = document.body.appendChild(plugin);

                        try {
                            if (typeof plugin["NPWWVersion"] === 'function') {
                                var v = self.numberify(plugin.NPWWVersion());
                                if (v >= 1.002) {
                                    self.atmClientFlag = 2;
                                } else {
                                    self.atmClientFlag = 1;
                                }
                            } else {
                                self.atmClientFlag = -1;
                            }
                        } catch (e) {
                        }
                    } else {
                        self.atmClientFlag = -1;
                    }
                }
            }
            // Mac系统下
            else {
                var mimetype = navigator.mimeTypes["application/ww-plugin"];
                if (mimetype) {
                    var plugin = document.createElement("embed");
                    plugin.setAttribute('type', 'application/ww-plugin');
                    plugin.style.height = '0px';
                    plugin.style.width = '0px';
                    plugin.style.visibility = 'hidden';
                    document.body.appendChild(plugin);
                    try {
                        if (plugin.isMacWWInstalled()) {
                            self.atmClientFlag = 3;
                        } else {
                            self.atmClientFlag = -1;
                        }
                    } catch (e) {
                        self.atmClientFlag = -1;
                    }
                    plugin.parentNode.removeChild(plugin);
                }
            }
            // TODO 不能这么写
            //arguments.callee.counter = 1;
        },
        // 检测firefox&chrome plugin是否安装并启用
        isPluginReady: function () {
            if (this.isMac()) {
                return true;
            }
            if (this.isFirefox() || this.isChrome()) {
                return (!!this.pluginMime && !!this.pluginMime.enabledPlugin);
            }
            return true;
        },
        // 检测TradeManger客户端是否已安装
        isClientReady: function () {
            if (this.isPluginReady()) {
                this.checkClient();
                return this.atmClientFlag != -1;
            }
            return false;
        },
        // 检测执行ATM客户端指令的条件是否已经具备
        isReady: function () {
            return this.hasClient;
        },
        // 返回ATM客户端安装状态标识atmClientFlag
        getClientFlag: function () {
            if (this.isClientReady()) {
                return this.atmClientFlag;
            }
            return -1;
        },
        systemCall: function (cmd) {
            // 在win7以前的系统中, 自定义系统调用可能会导致出现错误:
            // "SCRIPT122: 传递给系统调用的数据区域太小"
            // 使用iframe可解决此问题
            if (cmd.length > 508) {
                var id = 'alitalk-hidden-iframe';

                // 必须删除旧的iframe, 否则在IE中会导致在新窗口中打开调用链接, 而不是进行调用
                $('#' + id).remove();

                $('<iframe/>', {
                    'id': id,
                    'name': 'alitalkHiddenIframe',
                    'src': cmd,
                    'style': 'display: none;'
                }).appendTo(document.body);
            } else {
                window.location = cmd;
            }
        },
        parseQuery: function (query) {
            var params = {};

            if (typeof query === 'string' || query instanceof String) {
                var pieces = query.split('&');

                for (var i = 0, len = pieces.length; i < len; i ++) {
                    var kv = pieces[i].split('=');

                    params[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
                }
            }

            return params;
        },
        genQuery: function (params) {
            return $.param(params);
        },
        getLoginId: function () {
            var cookie = this.parseQuery(Cookie.get('xman_us_t'));

            return cookie['x_lid'];
        },
        // 通过atm plugin/ActiveXObject执行ATM客户端指令
        execCommand: function (cmd) {
            if (!this.isReady()) {
                return false;
            }
            /*@debug
            console.log('exec: ' + cmd);
            */

            switch (this.atmClientFlag) {
                case 0:
                    this.systemCall(cmd);
                    break;
                case 1:
                    try {
                        this.atm.ExecCmd(cmd);
                    } catch (e) {
                        this.systemCall(cmd);
                    }
                    break;
                case 2:
                    this.atm.SendCommand(cmd, 2);
                    break;
                case 3:
                    this.systemCall(cmd);
                    break;
                default:
                    this.systemCall(cmd);
            }
        },
        buildQuery: function (query) {
            if (query !== undefined && query !== '') {
                if (query.substring(0, 1) != '&') {
                    return '&' + query;
                }
                return query;
            }
            return '';
        },
        chatTo: function (toUid, extraQuery) {
            if (!this.isReady()) {
                return false;
            }

            if (this.atmClientFlag == 0) {
                this.execCommand('TradeManager:SendIM_Encrypted?' + toUid);
            } else {
                var loginId = this.getLoginId();
                if (loginId) {
                    loginId = 'enaliint' + loginId;
                } else {
                    loginId = '';
                }

                this.execCommand('aliim:sendmsg?' + this.genQuery({
                    touid: toUid,
                    uid: loginId,
                    siteid: 'enaliint',
                    fenliu: 1,
                    status: 1,
                    encrypt: 1
                }) + this.buildQuery(extraQuery));
            }
        }
    });

    module.exports = new ATMPlugin();
